import styled from 'styled-components';

export const TabContent = styled.div`
  min-height: 0;
  min-width: 0;
`;
